import { render, staticRenderFns } from "./RiderCategoryCreate.vue?vue&type=template&id=1fa08022&lang=pug"
import script from "./RiderCategoryCreate.vue?vue&type=script&lang=js"
export * from "./RiderCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports